import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';

export const APP_NAME = 'Pouch';
export const COMPANY_NAME = 'GetPouch Technology Ltd';
export const API_BASE_URL = process.env.REACT_APP_BASE_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = '/dashboard';
export const UNAUTHENTICATED_ENTRY = '/login'
export const GRANT_TYPE = process.env.REACT_APP_GRANT_TYPE
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID

export const SUB_URL = '/api/management/school'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#4504BF',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
